// Static menu data for El Loco Taco — Hartford, MI
export const MEATS = [
  "Steak (Asada)",
  "Pork (Al Pastor)",
  "Chicken (Pollo)",
  "Beef",
  "Tongue (Lengua)",
  "Tripe (Tripa)",
  "Chorizo",
];

export const MENU_CATEGORIES = [
  {
    key: "tacos",
    title: "Tacos",
    blurb: "Warm corn tortillas, cilantro, onion, lime. The classic.",
    items: ["Street Tacos — pick your meat"],
  },
  {
    key: "tortas",
    title: "Tortas",
    blurb: "Crisp telera bread stacked tall with your favorite meat.",
    items: ["Classic Torta — pick your meat"],
  },
  {
    key: "burritos",
    title: "Burritos",
    blurb: "Oversized flour tortilla, rice, beans, the works.",
    items: ["House Burrito — pick your meat"],
  },
  {
    key: "quesadillas",
    title: "Quesadillas",
    blurb: "Melted cheese, golden tortilla, seriously loaded.",
    items: ["Quesadilla — pick your meat"],
  },
  {
    key: "huaraches",
    title: "Huaraches",
    blurb: "Sandal-shaped masa base topped the Mexico City way.",
    items: ["Huarache — pick your meat"],
  },
  {
    key: "gorditas",
    title: "Gorditas",
    blurb: "Thick handmade masa pockets, crispy outside, tender inside.",
    items: ["Gordita — pick your meat"],
  },
  {
    key: "enchiladas",
    title: "Enchiladas",
    blurb: "Rolled tortillas drowned in red salsa & queso.",
    items: ["Enchiladas — pick your meat"],
  },
  {
    key: "flautas",
    title: "Flautas",
    blurb: "Crunchy rolled tacos, crema, lettuce, queso fresco.",
    items: ["Flautas — pick your meat"],
  },
  {
    key: "fajitas",
    title: "Fajitas",
    blurb: "Sizzling peppers & onions with your choice of meat.",
    items: ["Fajitas — pick your meat"],
  },
  {
    key: "quesabirria",
    title: "Quesabirrias",
    blurb: "Slow-cooked birria, melted cheese, consomé for dipping.",
    items: ["Quesabirria (3 tacos + consomé)"],
    badge: "FAN FAVORITE",
  },
  {
    key: "sides",
    title: "Sides",
    blurb: "Hand-cooked, house-made.",
    items: ["Side Rice", "Side Beans"],
  },
  {
    key: "sweets",
    title: "Sweets & Snacks",
    blurb: "For the after-taco moment.",
    items: ["Churros", "Elote in a Cup"],
  },
];

export const DRINKS = {
  highlight: {
    name: "Horchata",
    tagline: "Our main drink — creamy, cinnamon, ice cold.",
  },
  others: [
    "Jarritos (assorted flavors)",
    "Coke — Can",
    "Coke — Mexican Glass Bottle",
    "Pepsi",
    "Diet Coke",
    "Monster Energy",
    "Red Bull",
  ],
};

export const HOURS = [
  { day: "Monday", time: "11:00 AM – 8:00 PM", closed: false },
  { day: "Tuesday", time: "CLOSED", closed: true },
  { day: "Wednesday", time: "11:00 AM – 8:00 PM", closed: false },
  { day: "Thursday", time: "11:00 AM – 8:00 PM", closed: false },
  { day: "Friday", time: "11:00 AM – 8:00 PM", closed: false, weekend: true },
  { day: "Saturday", time: "11:00 AM – 8:00 PM", closed: false, weekend: true },
  { day: "Sunday", time: "8:00 AM – 8:00 PM", closed: false, weekend: true },
];

export const CONTACT = {
  name: "El Loco Taco",
  city: "Hartford, MI",
  address: "309 West Main Street, Hartford, MI",
  phones: [
    { display: "(912) 246-1324", href: "tel:+19122461324" },
    { display: "(269) 277-2972", href: "tel:+12692772972" },
  ],
  facebook: "https://www.facebook.com/share/1AGNnukLfR/?mibextid=wwXIfr",
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_71cf1850-9d80-49b3-817b-71ddb882897c/artifacts/uufwyl6a_image.png",
  truck: "https://customer-assets.emergentagent.com/job_71cf1850-9d80-49b3-817b-71ddb882897c/artifacts/ys299dbz_image.png",
  storefront: "https://customer-assets.emergentagent.com/job_71cf1850-9d80-49b3-817b-71ddb882897c/artifacts/ep6hkww0_image.png",
  horchata: "https://images.pexels.com/photos/34567578/pexels-photo-34567578.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  catering: "https://images.unsplash.com/photo-1700625914525-54dba25d2125?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtZXhpY2FuJTIwZm9vZCUyMGNhdGVyaW5nfGVufDB8fHx8MTc3NzM0MDk1NHww&ixlib=rb-4.1.0&q=85",
};
